import {action, makeAutoObservable, observable, runInAction} from "mobx";
import {inject, injectable} from "inversify";
import {orderBy, uniq} from 'lodash';
import {Bindings} from "data/constants/bindings";
import {type IJSONProvider} from "data/providers/json/json.provider";

export interface IDivision {
	id: number;
	conferenceId: number;
	abbreviation: string;
	name: string;
}

export interface IDivisionsStore {
	get divisions(): IDivision[];
	get sortedDivision(): IDivision[];

	divisionById: (divisionId: number) => IDivision | undefined;
	divisionsIdsByConferenceId: (conferenceId: number) => number[];
	fetchDivisions(): Promise<void>;
}

@injectable()
export class DivisionsStore implements IDivisionsStore {
	@observable private _list: IDivision[] = [];

	get divisions() {
		return this._list;
	}

	get sortedDivision() {
		return orderBy(this.divisions, ["name"], ["desc"]);
	}

	constructor(@inject(Bindings.JSONProvider) private _jSONProvider: IJSONProvider) {
		makeAutoObservable(this);
	}

	divisionById = (divisionId: number) => {
		return this._list.find((it) => it.id === divisionId);
	};

	divisionsIdsByConferenceId = (conferenceId: number) => {
		return uniq(
			this._list
				.filter((it) => it.conferenceId === conferenceId)
				.map((it) => it.id)
		);
	}


	@action
	async fetchDivisions() {
		const {data} = await this._jSONProvider.divisions();

		runInAction(() => {
			this._list = data.items;
		});
	}
}
